import React, { Component, ErrorInfo, ReactNode } from "react";
import { Text, View } from "react-native";
import { lightTheme } from "@/theme/themes";
import { AppButton } from "@/ui/components/AppButton";

interface Props {
  children: ReactNode;
  fallback?: (error: Error, resetError: () => void) => ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.resetError);
      }

      return (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            padding: lightTheme.space.xl,
            backgroundColor: lightTheme.color.surface,
          }}
        >
          <Text
            style={{
              fontSize: lightTheme.fontSize.title,
              fontWeight: "bold",
              color: lightTheme.color.danger,
              marginBottom: lightTheme.space.lg,
            }}
          >
            Ups, etwas ist schiefgelaufen!
          </Text>

          <AppButton onPress={this.resetError}>
            Erneut versuchen
          </AppButton>
        </View>
      );
    }

    return this.props.children;
  }
}
